// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getSpaTypes} from '../../../claim/shared/repositories';

export const readSpaTypes = dealerId =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const spaTypes = await getSpaTypes(dealerId);

            dispatch({
                data: spaTypes.spaTypes,
                type: actions.UPDATE_TCSM_SPA_TYPES
            });

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateSpaType = (selectedType, spaTypes) => ({
    data: spaTypes.find(type => type.key === selectedType),
    type: actions.UPDATE_TCSM_SPA_TYPE
});



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/action-creators/spa-types.js